import { http } from '@/utils/http.util';

export default {
   async get({ search }: { search: string }) {
      return await http
         .get('/api/city', {
            params: { 'filter[search]': search, per_page: 25, include: 'country' },
         })
         .then((response) => response.data);
   },
};
